module.exports = __webpack_public_path__ + "img/radaway.854e4f2c.svg";